export default __webpack_public_path__ + "static/media/safeShopping.ecf9a867.png";